import React, { Component } from 'react'

export default class CurrencyName extends Component {

    render = () => {
        const { currencyCode } = this.props

        switch (currencyCode) {
            case 'ETH_UAX':
                return (
                    <>CryptoUAX</>
                )
            case 'UAH':
                return (
                    <>UAH</>
                )
            case 'RUB':
                return (
                    <>RUB</>
                )
            case 'LTC':
                return (
                    <>
                        Litecoin
                    </>
                )
            case 'XRP':
                return (
                    <>
                        Ripple
                    </>
                )
            case 'ETH_USDT':
                return (
                    <>
                        Tether ERC20
                    </>
                )
            case 'ETH':
                return (
                    <>
                        Ethereum
                    </>
                )
            case 'BTC':
                return (
                    <>
                        Bitcoin
                    </>
                )
            case 'USDT':
                return (
                    <>
                        Tether OMNI
                    </>
                )
            case 'ETH_USDC':
                return (
                    <>
                        USD Coin
                    </>
                )
            case 'ETH_TRUE_USD':
                return (
                    <>
                        TrueUSD
                    </>
                )
            case 'ETH_PAX':
                return (
                    <>
                        Paxos Standard
                    </>
                )
            case 'TRX':
                return (
                    <>
                        Tron
                    </>
                )
            case 'TRX_BTT':
                return (
                    <>
                        BitTorrent
                    </>
                )
            case 'TRX_USDT':
                return (
                    <>
                        Tether TRС20
                    </>
                )
            case 'DOGE':
                return (
                    <>
                        Dogecoin
                    </>
                )
            case 'XVG':
                return (
                    <>
                        Verge
                    </>
                )
            case 'BSV':
                return (
                    <>
                        BitcoinSV
                    </>
                )
            case 'BTG':
                return (
                    <>
                        Bitcoin Gold
                    </>
                )
            case 'BCH':
                return (
                    <>
                        Bitcoin Cash
                    </>
                )
            case 'ETH_DAIM':
                return (
                    <>
                        Dai Stablecoin
                    </>
                )
            case 'ETH_MKR':
                return (
                    <>
                        Maker
                    </>
                )
            case 'ETH_OKB':
                return (
                    <>
                        OKB
                    </>
                )
            case 'ETH_KNC':
                return (
                    <>
                        KyberNetwork
                    </>
                )
            case 'ETH_BNT':
                return (
                    <>
                        Bancor
                    </>
                )
            case 'XMR':
                return (
                    <>
                        Monero
                    </>
                )
            case 'XLM':
                return 'Stellar'
            case 'BNB':
                return 'Binance Coin'
            case 'BNB_SMART':
                return 'BNB Smart Chain'
            case 'ETH_LINK':
                return 'ChainLink ERC20'
            case 'ETH_UNI':
                return 'Uniswap ERC20'
            case 'ETC':
                return 'Ethereum Classic'
            case 'ETH_SHIB':
                return 'Shiba ERC20'
            case 'TON':
                return 'TON'
            case 'BNB_SMART_ADA':
                return 'Cardano BEP20'
            default:
                return null
        }
    }
}
